function looksLikeHtml(value) {
  return /<\/?[a-z][\s\S]*>/i.test(value);
}

function RichTextContent({
  as: Component = 'div',
  className = '',
  fallback = '',
  html,
}) {
  const content = typeof html === 'string' ? html : '';

  if (!content.trim()) {
    return <Component className={className}>{fallback}</Component>;
  }

  if (looksLikeHtml(content)) {
    return (
      <Component
        className={`rich-text-content ${className}`.trim()}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    );
  }

  return (
    <Component className={`whitespace-pre-line ${className}`.trim()}>
      {content}
    </Component>
  );
}

export default RichTextContent;
